<template>
  <div>
    <dropdown>
      <template v-slot:dropdown-custom-title>{{
        choosen ? choosen : '---'
      }}</template>
      <template v-slot:dropdown-custom-menu>
        <li class="dropdown__search">
          <div class="d-flex">
            <input
              type="text"
              placeholder="Suche..."
              autocomplete="off"
              class="form-control search__input"
              v-model="search"
              @change="filterOptions"
            />
            <button v-if="search.length > 0" @click.stop="search=''" class="btn btn-sm btn-icon btn-secondary">
              <i class="icon icon-close"></i>
            </button>
          </div>
        </li>

        <li v-if="search.length == 0">
          <label class="checkbox checkbox--list ">
            <b>Alle</b>
            <input
              type="checkbox"
              :checked="selectedAll"
              @change="toggleAll()"
            />
            <span class="checkbox__checkmark checkbox__checkmark--list "></span>
          </label>
        </li>
        <template v-for="(group, i) in filterOptionsData">
          <li :key="'group' + i">
            <label class="checkbox checkbox--group-list ">
              <b>{{ group.name }}</b>
              <input type="checkbox"
                  :checked="selectedAll ? true : checkedGroup(group.items)"
                  @change="toggleGroup(group.items, $event.target)"
              />
              <span class="checkbox__checkmark checkbox__checkmark--group-list "></span>
            </label>
          </li>
          <template v-for="item in group.items">
            <li :key="'item' + item.id">
              <label class="checkbox checkbox--item-list">
                {{ item.name }}
                <input
                  type="checkbox"
                  :checked="selectedAll ? true : checked(item.id)"
                  @change="getValue(item.id)"
                />
                <span
                  class="checkbox__checkmark checkbox__checkmark--item-list"
                ></span>
              </label>
            </li>
          </template>
        </template>
      </template>
    </dropdown>
    <template v-for="i in hidden">
      <input :key="'hidden' + i" type="hidden" :name="name" :value="i" />
    </template>
  </div>
</template>

<script>
import Dropdown from "../../Dropdown/src/Dropdown.vue";

export default {
  components: {
    Dropdown,
  },
  props: {
    name: String,
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
      selectedAll: false,
      hidden: this.value,
      choosen: null,
      filterOptionsData: this.options,
    };
  },
  watch: {
    search: function () {
      this.filterOptions();
    }
  },
  methods: {
    filterOptions() {
      let list = [];
      this.options.forEach((optionGroup) => {
        let group = [];
        group['name'] = optionGroup.name;
        group['items'] = optionGroup.items.filter((optionItem) =>
          optionItem.name.toLowerCase().includes(this.search.toLowerCase())
        );
        group['items'].length > 0 ? list.push(group) : null;
      });
      this.filterOptionsData = list;
    },
    getValue(value) {
      const indexRemove = this.hidden.indexOf(value.toString());
      this.hidden.includes(value.toString())
        ? this.hidden.splice(indexRemove, 1)
        : this.hidden.push(value.toString());

      this.selectedAll = false;
      this.change();
    },
    checked(value) {
      return this.hidden.includes(value.toString());
    },
    checkedGroup(groupItems) {
      return groupItems.every((item) => {
        return this.hidden.includes(item.id.toString())
      });
    },
    toggleGroup(groupItems,element) {
      let selectedGroup = groupItems.every((item) => {
        return this.hidden.includes(item.id.toString())
      });
      let noOneSelected = groupItems.every((item) => {
        return !this.hidden.includes(item.id.toString())
      });
      if(selectedGroup || noOneSelected){
        groupItems.forEach((item) => {
          this.getValue(item.id);
        })
      }else{
        groupItems.forEach((item) => {
          if(element.checked){
            this.hidden.includes(item.id.toString())
              ? true
              : this.hidden.push(item.id.toString());
          }else{
            const indexRemove = this.hidden.indexOf(item.id.toString());
            this.hidden.includes(item.id.toString())
              ? this.hidden.splice(indexRemove, 1)
              : true;
          }
        })
      }
    },
    toggleAll() {
      this.hidden = [];

      if (!this.selectedAll) {
        this.filterOptionsData.forEach((option) => {
          option["items"].forEach((item) => {
            this.hidden.push(item.id.toString());
          });
        });
      }

      this.change();
      this.selectedAll = !this.selectedAll;
    },
    change() {
      let list = [];
      this.filterOptionsData.forEach((option) => {
        option.items.forEach((item) => {
          this.hidden.includes(item.id.toString())
            ? list.push(item.name)
            : false;
        });
      });
      this.choosen = list.join(", ");
    },
  },
  mounted() {
    this.change();
    this.options.forEach(option => {
      option['items'].forEach(item => {
        this.hidden.includes(item.id.toString()) ? this.selectedAll = true : this.selectedAll = false;
      });
    });
  }

};
</script>
